<article class="checkout sidebar" [class.has_recs]="show_recommendations"
  [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <div class="process">
      <sot-stepper activeStep="order"></sot-stepper>
      <div>&nbsp;</div>
    </div>

    <h1 langkey="order_title"></h1><!--Bestellübersicht-->
  </header>

  <div class="content" [class.has_recs]="show_recommendations" #product_list>
    <ng-container *ngFor="let product of products">
      <div class="dish" [class.noimg]="!product.hasImage">
        <div class="img" *ngIf="product.hasImage">
          <img [src]="product.imagePath" class="ya_image" *ngIf="product.hasImage">
        </div>
        <div class="content container">
          <div class="top">
            <header>
              <h2>{{product.label}}</h2>
              <div (click)="removeProduct(product)" class="close btn" inlineSVG="sot/sot-icon.svg#sot-close"
                [setSVGAttributes]="{class: 'icon-close'}"></div>
            </header>
            <span class="benefit-notice" *ngIf="isBenefitItem(product)" langkey="benefit_bonus"></span>
            <span class="coupon-notice" *ngIf="product.isCouponItem" langkey="coupons_redeem_cart_marker"></span>
            <p>{{product.extrasToStringArray().join(",\r\n")}}</p>
            <p class="deposit" *ngIf="product.has_deposit"><span langkey="details_incl_deposit"></span><!--ink. Pfand-->
            </p>
          </div>
          <footer>
            <ng-container *ngIf="isBenefitItem(product); then benefitFooter; else defaultFooter"></ng-container>
            <ng-template #benefitFooter>
              <div class="benefit-footer-wrapper">
                <div class="benefit-amount" (click)="openBonusActionDialogToEditBenefit(true)">
                  <sot-amount [amount]="product.count"></sot-amount>
                </div>
                <div class="preis">{{benefitPoints(product)}} <span langkey="benefit_label_of_points"></span></div>
              </div>
            </ng-template>
            <ng-template #defaultFooter>
              <sot-amount [(amount)]="product.count" [max]="maxAmountForProduct(product)"
                (amountChange)="productAmountChanged(product)"></sot-amount>
              <div (click)="editProduct(product)" class="edit" *ngIf="product.model.has_extras"
                inlineSVG="sot/sot-icon.svg#sot-edit" [setSVGAttributes]="{class: 'icon-edit'}"></div>
              <div class="preis">{{product.totalSum | price}}</div>
            </ng-template>
          </footer>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="scroll-bottom" *ngIf="show_product_list_bottom_scroll" inlineSVG="sot/sot-icon.svg#sot-down_arrows"
    [setSVGAttributes]="{class: 'arrows'}"></div>

  <aside>
    <div class="top">
      <sot-processcard *ngIf="processCard" [amount]="cardUsedAmount" [limit]="processCard.limit">
      </sot-processcard>

      <div class="container payment" *ngIf="allow_pay_at_card && processCard">
        <h3 langkey="process_order_completion_label">Karte scannen</h3>

        <a (click)="selectPayAtCard()" class="btn cardscan" [class.disabled]="!isCardUnderLimit"
          [class.disabled]="is_basket_empty">
          <span langkey="process_order_completion_head">Jetzt scannen</span>
          <div inlineSVG="sot/sot-icon.svg#sot-pay_at_terminal" flex [setSVGAttributes]="{class: 'aside-icon'}"></div>
        </a>
      </div>

      <div class="container amount">
        <h3 langkey="main_sum"></h3><!--SUMME-->
        <ng-container *ngIf="has_deposit">
          <p class="deposit"><span langkey="details_incl_deposit"></span><!--ink. Pfand--> <span class="preis">{{deposit
              | price}}</span></p>
        </ng-container>
        <ng-container *ngFor="let vat of vats">
          <p class="mwst"><span langkey="order_vat"></span><!--MwSt.--> {{vat.percentage}} % <span
              class="preis">{{vat.vat | price}}</span></p>
        </ng-container>
        <p class><span langkey="main_total"></span><!--Gesamtbetrag--> <span class="preis">{{sum | price}}</span></p>
      </div>
      <div class="content-wrapper">
        <!-- Benefit redeem -->
        <ng-container *ngIf="canDisplayRedeemBenefitBtn">
          <div class="container redeem-benefit">
            <h3 langkey="benefit_button_redeem"></h3>
            <a class="btn bonus" (click)="openScanVoucherToRedeemBenefit()">
              <span langkey="benefit_button_redeem"></span>
              <div inlineSVG="sot/sot-icon.svg#sot-bonus" flex [setSVGAttributes]="{class: 'aside-icon'}"></div>
            </a>
          </div>
        </ng-container>
        <!-- Payment Methods -->
        <ng-container *ngIf="allow_pay_at_terminal || allow_pay_at_pos || allowVoucherPay|| useBonusSystem">
          <div class="container payment">
            <h3 langkey="order_paymethod"></h3><!--Zahlungsart-->
            <ng-container *ngIf="allow_pay_at_terminal && allow_pay_at_pos">
              <span langkey="order_select_paytype"></span><!--Bitte wählen:-->
            </ng-container>

            <a *ngIf="allow_pay_at_terminal" class="btn pay" (click)="selectPayAtTerminal()"
              [class.disabled]="is_basket_empty">
              <span langkey="order_type_terminal"></span><!--Bargeldlos-->
              <div inlineSVG="sot/sot-icon.svg#sot-pay_at_terminal" flex [setSVGAttributes]="{class: 'aside-icon'}">
              </div>
            </a>
            <a *ngIf="allowVoucherPay || useBonusSystem" class="btn pay voucher" (click)="selectVoucherPay()"
              [class.disabled]="is_basket_empty">
              <span langkey="button_order_type_voucher"></span><!--Gutschein-->
              <div inlineSVG="sot/sot-icon.svg#sot-qrscan" flex [setSVGAttributes]="{class: 'aside-icon'}"></div>
            </a>
            <a *ngIf="allow_pay_at_pos" class="btn pay" (click)="selectPayAtPOS()" [class.disabled]="is_basket_empty">
              <span langkey="order_type_pos"></span><!--An der Kasse bezahlen-->
              <div inlineSVG="sot/sot-icon.svg#sot-pay_at_pos" flex [setSVGAttributes]="{class: 'aside-icon'}"></div>
            </a>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="bottom">
      <sot-backbtn (click)="back()"></sot-backbtn>
    </div>
  </aside>

  <footer *ngIf="show_recommendations" class="recs">
    <h1 langkey="order_recommendation"></h1><!--Möchten Sie noch etwas hinzufügen?-->
    <div class="close btn" (click)="closeRecommendations()" inlineSVG="sot/sot-icon.svg#sot-close"
      [setSVGAttributes]="{class: 'icon-close'}" style="display: none;">
      <!-- todo "display: none;" weil momentan das schließen verhindern sol, step 2 ausarbeiten was getanwerden muss-->
    </div>

    <a (click)="showPrevRecommendations()" class="btn noborder" [class.hide]="!has_prev_recomendation_page">
      <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
    </a>

    <ng-container *ngFor="let recomendation of getRecommendationsForSite()">
      <div class="dish" [class.noimg]="!recomendation.has_image" (click)="openProduct(recomendation)">
        <div class="img">
          <img [src]="recomendation.image_path" class="ya_image" *ngIf="recomendation.has_image">
        </div>
        <div class="content container">
          <div class="top">
            <header>
              <h2>{{recomendation.label}}</h2>
            </header>
            <p [truncatedText]="recomendation.details.description"></p>
          </div>
          <footer>
            <div class="preis">{{recomendation.priceWithExtras | price}}</div>
            <a class="btn">
              <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
            </a>
          </footer>
        </div>
      </div>
    </ng-container>

    <a (click)="showNextRecommendations()" class="btn noborder" [class.hide]="!has_next_recomendation_page">
      <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
    </a>
  </footer>
</article>